import { EditorRotateDraftOperation } from '../editor-domain.models';

export class RotateViewModel {
  static readonly MIN_PRECISE_ANGLE = -180;

  static readonly MAX_PRECISE_ANGLE = 180;

  flipX = false;

  flipY = false;

  cut = false;

  get rightAngle(): number {
    return this.rightAngle$;
  }

  get totalAngle(): number {
    const rawTotal = this.rightAngle$ + this.preciseAngle;
    if (
      rawTotal >= RotateViewModel.MIN_PRECISE_ANGLE &&
      rawTotal <= RotateViewModel.MAX_PRECISE_ANGLE
    ) {
      return rawTotal;
    }

    const normalized = ((rawTotal % 360) + 360) % 360;
    return normalized > 180 ? normalized - 360 : normalized;
  }

  preciseAngle = 0;

  rotateClockwise() {
    this.rightAngle$ += 90;
    if (this.rightAngle$ > 270) {
      this.rightAngle$ -= 360;
    }
  }

  rotateCounterClockwise() {
    this.rightAngle$ -= 90;
    if (this.rightAngle$ < 0) {
      this.rightAngle$ += 360;
    }
  }

  private rightAngle$ = 0;

  setTotalAngle(nextValue: number): void {
    if (Number.isNaN(nextValue)) {
      this.rightAngle$ = 0;
      this.preciseAngle = 0;
      return;
    }

    if (nextValue === Number.POSITIVE_INFINITY) {
      nextValue = RotateViewModel.MAX_PRECISE_ANGLE;
    } else if (nextValue === Number.NEGATIVE_INFINITY) {
      nextValue = RotateViewModel.MIN_PRECISE_ANGLE;
    }

    const normalizedTotal = Math.max(
      RotateViewModel.MIN_PRECISE_ANGLE,
      Math.min(Math.round(nextValue), RotateViewModel.MAX_PRECISE_ANGLE),
    );

    if (normalizedTotal === RotateViewModel.MIN_PRECISE_ANGLE) {
      this.rightAngle$ = 0;
      this.preciseAngle = RotateViewModel.MIN_PRECISE_ANGLE;
      return;
    }

    const snappedRightAngle = Math.trunc(normalizedTotal / 90) * 90;
    this.rightAngle$ = ((snappedRightAngle % 360) + 360) % 360;
    this.preciseAngle = normalizedTotal - snappedRightAngle;
  }

  getRotateParams(): EditorRotateDraftOperation['params'] {
    return {
      rightAngle: this.rightAngle$,
      preciseAngle: this.preciseAngle,
      flipX: this.flipX,
      flipY: this.flipY,
      cut: this.cut,
    };
  }
}
